import { useSelector } from 'react-redux';
import { IMunicipalityConfig } from './municipalityConfig';
import { State } from '../reducers';

export const FETCH_CONFIGDATA_BEGIN = 'FETCH_CONFIGDATA_BEGIN';
export const FETCH_CONFIGDATA_SUCCESS = 'FETCH_CONFIGDATA_SUCCESS';
export const FETCH_CONFIGDATA_FAILURE = 'FETCH_CONFIGDATA_FAILURE';

export const fetchConfigDataBegin = () => ({
  type: FETCH_CONFIGDATA_BEGIN
});

export const fetchConfigDataSuccess = (userprofile: IMunicipalityConfig) => ({
  type: FETCH_CONFIGDATA_SUCCESS,
  payload: userprofile
});

export const fetchConfigDataFailure = (error: Error) => ({
  type: FETCH_CONFIGDATA_FAILURE,
  payload: error
});

export const useEstateConfig = () => {
  return useSelector((state: State) => state.config.config?.estateService)
}

export const useInboxConfig = () => {
  return useSelector((state: State) => state.config.config?.inboxService);
}

export const useInvoiceConfig = () => {
  return useSelector((state: State) => state.config.config?.invoiceService);
}

export const usePropertyTaxConfig = () => {
  return useSelector((state: State) => state.config.config?.estateTaxService);
}

export const useSweepingConfig = () => {
  return useSelector((state: State) => state.config.config?.sweepingService);
}

export const useProfileConfig = () => {
  return useSelector((state: State) => state.config.config?.profileService);
}